import { Navigate } from "react-router-dom";
export default function BillingInfo() {
  return <Navigate to="/settings?section=billing" replace />;
}
